import { Pipe, PipeTransform } from '@angular/core';
import { HelperManager } from '../../managers/helper.manager';
import { parsePhoneNumber } from 'libphonenumber-js/max';
import { Telephone } from '../../model/telephone';

@Pipe({ name: 'asFormatPhoneNumber' })
export class FormatPhoneNumber implements PipeTransform {
  constructor(public helperManager: HelperManager) {}

  transform(value: string): string {
    if (value) {
      try {
        return parsePhoneNumber(value, 'BE').formatNational();
      } catch (err) {
        return value;
      }
    } else {
      return '';
    }
  }

  transformTelephone(telephone: Telephone): string {
    return telephone == null ? '' : this.transform(telephone.number);
  }
}
